<script setup>
defineProps({
  image: {
    type: Object,
    default: () => {},
  },
  title: {
    type: String,
    default: () => '',
  },
  description: {
    type: String,
    default: () => '',
  },
  theme: {
    type: String,
    default: () => '',
  },
});
</script>
<template>
  <div class="car-technology" :class="`car-technology--${theme}`">
    <div v-if="image" class="car-technology__media">
      <NuxtImg
        v-if="image?.src"
        :src="image.src"
        :alt="image.alt"
        :height="image.height"
        :width="image.width"
        class="car-technology__image"
        loading="lazy"
      />
    </div>
    <div class="car-technology__info">
      <p
        v-if="title"
        class="mb-0 car-technology__title h5"
        v-html="title"
      ></p>
      <div
        v-if="description"
        class="car-technology__description body-3-regular"
        v-html="description"
      ></div>
    </div>
  </div>
</template>
<style scoped lang="scss">
@use 'sass:math';
.car-technology {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  height: 100%;
  padding: 16px;
  &--white {
    background-color: $gray;
  }
  &--black {
    background-color: rgba($surface-container-opacity, 0.5);
  }
  &--gray {
    background-color: $white;
  }
  @include media-breakpoint-up(sm) {
    gap: 48px;
    padding: 24px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(border-radius, 8);
    @include responsive-spacing(gap, 48);
    @include responsive-spacing(padding, 24);
  }
  &__media {
    border-radius: 4px;
    aspect-ratio: 1/1;
    max-width: 46%;
    overflow: hidden;
    @include media-breakpoint-up(sm) {
      max-width: 42.7%;
    }
    @include media-breakpoint-up(md) {
      max-width: 38.1%;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(border-radius, 4);
    }
  }
  &__image {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
  &__info {
    display: flex;
    flex-direction: column;
    gap: 16px;
    @include media-breakpoint-up(sm) {
      gap: 24px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 24);
    }
  }
  &__title {
    margin: 0;
    @include media-breakpoint-up(sm) {
      max-width: 70%;
    }
    @include media-breakpoint-up(md) {
      max-width: 76.2%;
    }
  }
  &__description {
    @include media-breakpoint-up(md) {
      max-width: 76.2%;
    }
  }
}
</style>
